import axios from "axios";
import { axiosInstance } from ".";
import { showHideLoader } from "../../store/Loader/actions";
import store from "../../store";

const uploadS3 = async (uploadUrl, file, onProgress) => {
  if (!uploadUrl || !file) {
    throw new Error("Missing uploadUrl or file");
  }

  return await axios.put(uploadUrl, file, {
    headers: {
      "Content-Type": file.type || "application/octet-stream"
    },
    transformRequest: [(data) => data],
    onUploadProgress: onProgress
      ? (e) => {
          const percent = Math.round((e.loaded * 100) / e.total);
          onProgress(percent);
        }
      : undefined
  });
};

const uploadToS3WithPresignedURL = async (
  infoFile,
  file,
  is_public = false,
  onProgress
) => {
  try {
    // 1- Get presigned URL
    const { data, status } = await axiosInstance.post(
      `/uploads/presign?is_public=${is_public}`,
      infoFile
    );

    if (status !== 200) {
      throw new Error(`Presign failed: ${status}`);
    }

    const uploadUrl = data?.upload?.upload_url;
    const key = data?.upload?.key;

    // 2- Upload file to S3
    store.dispatch(showHideLoader(true));

    try {
      await uploadS3(uploadUrl, file, onProgress);
      return { key, success: true };
    } finally {
      store.dispatch(showHideLoader(false));
    }
  } catch (error) {
    console.error("Presigned upload error:", error);
    return {
      success: false,
      message: error?.response?.data?.message || error.message
    };
  }
};

export { uploadToS3WithPresignedURL };
